<template>
  <div>
    <basic-container>
      <template>

        <el-table
          :data="propertiesViceList"
          border
        >
          <el-table-column
            prop="secondClassifyName"
            align="center"
            label="字段名"
          >
            <template slot-scope="scope">{{scope.row.title}}</template>
          </el-table-column>
          <el-table-column
            prop="secondClassifyName"
            align="center"
            label="值"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.dataType!='img'">{{scope.row.value}}</template>
              <template v-if="scope.row.dataType=='img'">
                <viewer :images="formmaterImage(scope.row.value)">
                  <img
                    v-for="src in formmaterImage(scope.row.value)"
                    :src="src"
                    :key="src"
                    width="20"
                  />
                </viewer>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="serviceFee">
          <el-table-column
            prop="secondClassifyName"
            align="center"
            border
          >
            <template slot-scope="scope">{{scope.row.key}}</template>
          </el-table-column>
          <el-table-column
            prop="secondClassifyName"
            align="center"
            border
          >
            <template slot-scope="scope">{{scope.row.value}}</template>
          </el-table-column>
        </el-table>
      </template>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { workOrderOption } from "@/const/salesCloud/workOrderOption";
import {
  serviceListing,
  statusSearch,
  findWorkOrderList,
  findCategoryAll,
  updateWorkOrderMerchants,
  evaluation,
  immediatePay,
  findItemsByCategory,
  findUsersByUserTypeAll,
  findUsersByUserType,
  balancePay,
  insertWorkOrderMerchants,
  userPass,
  userRefused,
  cancelWorkOrder,
  downloadExcelWorkOrder
} from "@/api/salesCloud/workOrder";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
import { findBalance, addBalance } from "@/api/salesCloud/accountBalance";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import { findUserInfo } from "@/api/basic/user";
import { formatterDateToUTC, parseStatus } from "@/util/util";
import { DIC } from "@/const/dic";
import { exportExcel } from "xlsx-oc";
import VueQr from "vue-qr";
export default {
  name: "workOrder",
  components: {
    VueQr
  },
  data() {
    return {
      dataDialog: false,
      propertiesViceList: [],
      serviceFee: [],
      workId: ""
    };
  },
  created() {
    this.workId = this.$router.currentRoute.query.id;
    this.serviceListing(this.workId);
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    serviceListing(id) {
      serviceListing(id).then(res => {
        this.workOrderData = [];
        this.serviceFee = [];
        this.propertiesViceList = [];
        let data = JSON.parse(res.data);
        this.workOrderData = data;
        this.propertiesViceList = data.propertiesViceList;
        let obj = { key: "收费标准", value: data.serviceFee.servicePrice };
        let obj1 = {
          key: "其他费用",
          value: data.serviceFee.otherExpensesAmount
        };
        let obj2 = {
          key: "其他费用备注",
          value: data.serviceFee.otherChargesDesc
        };
        let obj3 = { key: "总费用", value: data.serviceFee.servicePriceTotal };
        this.serviceFee.push(obj);
        this.serviceFee.push(obj1);
        this.serviceFee.push(obj2);
        this.serviceFee.push(obj3);
        console.log("工单详情:" + JSON.stringify(this.propertiesViceList));
        console.log("serviceFee:" + JSON.stringify(this.serviceFee));
      });
    },
    formmaterImage(row) {
      let str = new Array();
      console.log("row：" + JSON.stringify(row));
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    }
  }
};
</script>

<style lang="scss">
.remittanceButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}
.remittance {
  .recharge {
    margin-top: 10px;
  }
}
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
